"use strict";

var _require = require('boolean'),
    parseBoolean = _require["boolean"];

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function parseVellumJackets(params) {
  var quantity = getValueOfKeyMatching(params, /^invitations|^lp_invitations|^floral_invitations|REPRINT.*_invitations/);

  if (params.REPRINT_vellum_jackets === 'No') {
    return;
  }

  if (params.vellum_jackets_invitations) {
    if (parseBoolean(params.vellum_jackets_invitations)) {
      this.vellumJackets.add({
        quantity: quantity
      });
    }
  } else if (quantity > 0) {
    this.vellumJackets.add({
      quantity: quantity
    });
  }
}

module.exports = parseVellumJackets;